export const GET_PLAYSTATION = "GET_PLAYSTATION";
export const GET_PLAYSTATION_SUCCESS = "GET_PLAYSTATION_SUCCESS";
export const GET_PLAYSTATION_FAIL = "GET_PLAYSTATION_FAIL";

export const ADD_PLAYSTATION_SUCCESS = "ADD_PLAYSTATION_SUCCESS";
export const ADD_PLAYSTATION_FAIL = "ADD_PLAYSTATION_FAIL";
export const UPDATE_PLAYSTATION_SUCCESS = "UPDATE_PLAYSTATION_SUCCESS";
export const DELETE_PLAYSTATION_SUCCESS = "DELETE_PLAYSTATION_SUCCESS";
